<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <component-header
          title="Create FAQ"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Faqs' })"
        />
      </b-col>
      <b-col md="12">
        <b-card
          ><ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-row v-if="userRole === 'Tenant'">
              <b-col md="4">
                <span>Scope</span>
              </b-col>
              <b-col md="8">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="scope"
                >
                  <eb-select
                    type="text"
                    v-model="scope"
                    :options="scopeOptions"
                    label="label"
                    placeholder="Select scope"
                  ></eb-select>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <span>Category</span>
              </b-col>
              <b-col md="8">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="category"
                >
                  <eb-select
                    type="text"
                    v-model="category"
                    :options="categoryOptions"
                    label="label"
                    placeholder="Select category"
                  ></eb-select>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <span>Topic</span>
              </b-col>
              <b-col md="8">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="topic"
                  >
                    <b-form-input
                      class="custom-transform-class"
                      inputType="text"
                      placeholder="Topic"
                      v-model="topic"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <span>Description</span>
              </b-col>
              <b-col md="8">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="description"
                  >
                    <b-form-textarea
                      v-model="description"
                      placeholder="Enter something..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <span>Media Type</span>
              </b-col>
              <b-col md="8">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="Media Type"
                >
                  <eb-select
                    type="text"
                    v-model="mediatype"
                    :options="mediaOptions"
                    label="label"
                    @select="onSelect"
                    placeholder="Select Media Type"
                  ></eb-select>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
            </b-row>
            <b-row
              v-if="
                mediatype == 'VIDEO' ||
                mediatype == 'IMAGE' ||
                mediatype == 'DOCUMENT'
              "
            >
              <b-col md="4">
                <span>Upload Media</span>
              </b-col>
              <b-col md="8">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, validate }"
                  name="Media"
                >
                  <b-form-file
                    id="filePicker"
                    @change="validate"
                    v-on:change="changePhoto"
                    :state="Boolean()"
                    :accept="uploadFileType"
                    placeholder="Choose a Media..."
                    drop-placeholder="Drop Media here..."
                  ></b-form-file>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col md="1" v-if="showLoader">
                <div class="spinner-border text-primary" role="status"></div>
              </b-col>
            </b-row>
            <span v-if="invalidFile" class="validate-error"
              >Invalid File format</span
            >
            <hr />
            <div class="text-center mt-3 mb-3">
              <eb-button
                class="btn mr-4 fixed-width-btn"
                classic="mr-1 btn-primary"
                text="Save"
                :disabled="invalid || invalidFile || showLoader"
                @click.prevent="handleSubmit"
              ></eb-button>
            </div>
          </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import faqdetails from "@/components/MasterSetup/FAQ/FAQDetails.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "createfaq",
  components: {
    ebButton,
    cInput,
    ebSelect,
    faqdetails,
    ValidationObserver,
    ValidationProvider,
    ComponentHeader,
  },

  data: () => {
    return {
      show: true,
      mediatype: "",
      photo: "",
      scope: "",
      mediaOptions: ["VIDEO", "IMAGE", "DOCUMENT"],
      categoryOptions: ["Order", "Payment", "CASHBACK"],
      scopeOptions: ["PARTNER", "CUSTOMER"],
      category: "",
      showLoader: false,
      invalidFile: false,
      topic: "",
      description: "",
    };
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    uploadFileType() {
      if (this.mediatype == "IMAGE") return "image/*";
      if (this.mediatype == "VIDEO") return "video/*";
      return "text/*,application/*";
    },
  },
  methods: {
    onSelect() {
      if (this.mediatype == "image") {
        show = "false";
      }
    },
    async uploadFile(file) {
      this.$toasted.info("Uploading...");
      this.showLoader = true;
      if (this.mediatype !== "IMAGE") {
        await this.$store
          .dispatch("inventory/uploadVideoToStorage", file)
          .then((res) => {
            this.photo = res.data.fileUrl;
          })
          .catch((error) => {
           // this.$swal({
             // type: "error",
             // text: "File Upload failed! please try again.",
           // });
          });
        this.$toasted.success("Upload Complete");
      } else {
        let dataobj = {
          image: file,
          key: (
            Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
          ).toLowerCase(),
          isPublic: true,
          replaceExisting: true,
          basePath: "faq",
        };

        // await this.$store
        //   .dispatch("inventory/uploadImageToStorage", dataobj)
        //   .then((res) => {
        //     this.photo = res.data.fileUrl;
        //   })
        //   .catch((error) => {
        //    // this.$swal({
        //      // type: "error",
        //      // text: "File Upload failed! please try again.",
        //     });
        //   });
        this.$toasted.success("Upload Complete");
      }
      this.showLoader = false;
    },
    changePhoto(e) {
      if (
        this.mediatype == "IMAGE" &&
        !e.target.files[0].type.match("image.*")
      ) {
        this.invalidFile = true;
        e.target.value = "";
        return;
      }

      if (
        this.mediatype == "VIDEO" &&
        !e.target.files[0].type.match("video.*")
      ) {
        this.invalidFile = true;
        e.target.value = "";
        return;
      }
      if (
        this.mediatype == "DOCUMENT" &&
        !(
          e.target.files[0].type.match("application.*") ||
          e.target.files[0].type.match("text.*")
        )
      ) {
        this.invalidFile = true;
        e.target.value = "";
        return;
      }
      this.invalidFile = false;
      if (this.mediatype !== "IMAGE") {
        if (e.target.files.length != 0) {
          const formData = new FormData();
          formData.append("file", e.target.files[0]);
          formData.append("isPublic", "true");
          formData.append("replaceExisting", "true");
          formData.append("basePath", "faq");
          formData.append(
            "key",
            (
              Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
            ).toLowerCase()
          );
          this.uploadFile(formData);
        }
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = () => {
          this.uploadFile(reader.result);

          //this.$emit("readIMG", this.img);
        };
        reader.onerror = (err) => {
          console.error("reader : ", err);
        };
      }
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      let dataObj;
      if (
        JSON.parse(sessionStorage.getItem("userLogin"))["role"] === "Tenant"
      ) {
        dataObj = {
          category: this.category,
          scope: this.scope,
          item: {
            topic: this.topic,
            description: this.description,
            media: {
              mediaType: this.mediatype,
              mediaContent: this.photo,
            },
          },
        };
      } else {
        dataObj = {
          category: this.category,
          scope: "TENANT",
          item: {
            topic: this.topic,
            description: this.description,
            media: {
              mediaType: this.mediatype,
              mediaContent: this.photo,
            },
          },
        };
      }
      await this.$store.dispatch("faq/createFaq", dataObj).then(() => {
        this.$swal({
          title: "Success",
          text: "Faq added successfully!!",
          type: "success",
        });
         if (this.faqList && Array.isArray(this.faqList)) {
      this.faqList.unshift(dataObj);
    }
        
        this.$store.dispatch(
          "faq/fetchFaqsList",
          this.$store.getters["auth/getUserID"]
        );
         this.$router.push({ name: "Faqs" });
      });
    },
  },
  watch: {
    mediatype(newval, oldval) {
      if (newval != oldval) {
        if (this.photo != "") this.invalidFile = true;
        this.photo = "";
      }
    },
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
.fixed-width-btn {
  width: 100px;
  font-size: 15px;
}
</style>
